import React from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  makeStyles,
} from "@material-ui/core"
import { LinkButton } from ".."

const useStyles = makeStyles((theme) => ({
  paper: {
    width: theme.dimensions.dialogs.alerts.width,
  },
  title: {
    padding: theme.spacing(2),
    paddingBottom: 0,
  },
  content: {
    padding: theme.spacing(2),
  },
}))

const Alert = ({ open, onClose, title, description, hideOK, hideCancel, okLabel, cancelLabel }) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ paper: classes.paper }}
    >
      <Box pb={1}>
        <DialogTitle id="alert-dialog-title" classes={{ root: classes.title }}>
          {title}
        </DialogTitle>
        <DialogContent classes={{ root: classes.content }}>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {hideCancel || (
            <Box mr={2}>
              <LinkButton onClick={() => onClose(false)}>{cancelLabel || "Cancel"}</LinkButton>
            </Box>
          )}
          {hideOK || (
            <Box mr={1}>
              <Button onClick={() => onClose(true)} variant="contained" color="primary" autoFocus>
                {okLabel || "OK"}
              </Button>
            </Box>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export { Alert }
